import axios from "axios";
import { API_BASE } from "../config/themes";

export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token") || ""}` });

export const getApiErrorMessage = (err, fallback) => {
  if (err.response?.data?.detail) return err.response.data.detail;
  if (err.request) return "서버 연결이 일시적으로 불안정합니다. 백엔드 재시작 중이면 잠시 후 다시 시도해주세요.";
  return fallback;
};

export const api = axios.create({
  baseURL: API_BASE,
});

export const apiBase = API_BASE;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const isTransientApiError = (err) => {
  if (!err) return false;
  if (err.request && !err.response) return true;
  const status = err.response?.status;
  return [408, 425, 429, 500, 502, 503, 504].includes(status);
};

export const requestWithRetry = async (requester, options = {}) => {
  const {
    retries = 4,
    delayMs = 900,
    backoff = 1.6,
  } = options;

  let lastError;
  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      return await requester();
    } catch (err) {
      lastError = err;
      if (attempt >= retries || !isTransientApiError(err)) break;
      await sleep(Math.round(delayMs * Math.pow(backoff, attempt)));
    }
  }
  throw lastError;
};
